import { AdmService } from 'src/app/shared/services/adm.service';
import { Compania } from 'src/app/shared/models/compania';
import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { defaultValueOrRangeValidator, isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Pais } from 'src/app/shared/models/pais';
import { Router } from '@angular/router';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { TipoListaPrecio } from 'src/app/shared/models/tipoListaPrecio';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';

@Component({
  selector: 'app-tipos-listas-precios-dialog',
  templateUrl: './tipos-listas-precios-dialog.component.html'
})
export class TiposListasPreciosDialogComponent implements OnInit {

  companias: Compania[] = [];
  salesOrgs: SalesOrg[] = [];
  mensaje: number = 0;
  form: FormGroup;
  idTipo: number;
  tlp: TipoListaPrecio;
  codigoTlpEdit: number = -1;

  constructor(
    private admService: AdmService,
    private configService: ConfigService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<TiposListasPreciosDialogComponent>,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,
    private usuariosService: UsuariosService,

    @Inject(MAT_DIALOG_DATA) private data: any) {
    this.form = this.fb.group({
      id: ['', [Validators.required]],
      descripcion: ['', [Validators.required]],
      idCompania: ['', Validators.required],
      idSalesOrg: ['', Validators.required],
      idPais: [''],
      cliente: [false],
      autor: [''],
      habilitacion: [true],
      codigo: [0]
    })



    if (data.idTipo != null) {
      this.idTipo = data.idTipo;
    }
    if (data.tlp != null) {
      this.codigoTlpEdit = data.tlp.codigo
      this.tlp = data.tlp

    }
  }

  public Etiquetas: {

    AplicaDescuentos: string,
    CircuitoVentaAnticipada: string,
    Cliente: string,
    Descripcion: string,
    GenerarProforma: string,
    Habilitacion: string,
    Id: string,
    IdCompania: string,
    IdSalesOrg: string,

  }

  public Validaciones: {
    Compania: string;
    SalesOrg: string;
    Id: string;
    Descripcion: string;
  }


  ngOnInit() {
    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.mensaje));
    this.Etiquetas = {

      AplicaDescuentos: this.configService.etiquetas.TiposListasPrecios.AplicaDescuentos,
      Descripcion: this.configService.etiquetas.TerminosPago.Descripcion,
      CircuitoVentaAnticipada: this.configService.etiquetas.TiposListasPrecios.CircuitoVentaAnticipada,
      Cliente: this.configService.etiquetas.TiposListasPrecios.Cliente,
      Habilitacion: this.configService.etiquetas.Habilitacion,
      Id: this.configService.etiquetas.TerminosPago.Id,
      IdCompania: this.configService.etiquetas.Compania,
      IdSalesOrg: this.configService.etiquetas.SalesOrg,
      GenerarProforma: this.configService.etiquetas.TiposListasPrecios.GenerarProforma,

    }

    this.Validaciones = {

      Descripcion: this.configService.validaciones.Descripcion,
      Id: this.configService.validaciones.Codigo,
      Compania: this.configService.validaciones.Compania,
      SalesOrg: this.configService.validaciones.SalesOrg,

    }

    forkJoin([

      this.admService.cCompanias(this.loggedService.logged.idPais),
      this.admService.cSalesOrgs(this.loggedService.logged.idPais, this.loggedService.logged.idCompania),
      this.tablasService.cTipoListaPrecioDB(this.codigoTlpEdit)

    ]).subscribe((data: [Compania[], SalesOrg[], TipoListaPrecio]) => {

      if (data[0].length) {

        this.companias = data[0];
      }

      if (data[1].length) {

        this.salesOrgs = data[1];
      }


      if (this.idTipo == 1) {
        let paisPlaceHolder: Pais = new Pais();
        paisPlaceHolder.id = this.loggedService.logged.idPais;
        paisPlaceHolder.descripcion = "";
        this.form.controls['idPais'].setValue(paisPlaceHolder.id);
        if (this.companias.length) {
          this.form.controls['idCompania'].setValue(this.companias[0].id);
        }
        if (this.salesOrgs.length) {
          this.form.controls['idSalesOrg'].setValue(this.salesOrgs[0].id);
        }
      }

      if (typeof this.tlp != 'undefined') {
        if (this.codigoTlpEdit != -1) {
          if (data[2] != null) {

            this.form.controls['id'].setValue(data[2].id);
            this.form.controls['descripcion'].setValue(data[2].descripcion);
            this.form.controls['idCompania'].setValue(data[2].idCompania);
            this.form.controls['idPais'].setValue(data[2].idPais);
            this.form.controls['idSalesOrg'].setValue(data[2].idSalesOrg);
            this.form.controls['habilitacion'].setValue(data[2].habilitacion);
            this.form.controls['codigo'].setValue(data[2].codigo);
            this.form.controls['autor'].setValue(data[2].autor);
            this.form.controls['cliente'].setValue(data[2].cliente);
            this.form.markAsUntouched();
            this.form.markAsPristine();
          }
        }
      }

    });
  }

  compareCompanias(compLista: any, compTlp: any): boolean {
    if (typeof compLista != 'undefined' && typeof compTlp != 'undefined') {

      return compLista === compTlp;
    }
  }

  compareSalesOrgs(salesOrgLista: any, salesOrgTlp: any): boolean {
    if (typeof salesOrgLista != 'undefined' && typeof salesOrgTlp != 'undefined') {

      return salesOrgLista === salesOrgTlp;
    }
  }

  guardarTipoListaPrecio() {

    switch (this.idTipo) {
      case 1:
        this.form.controls['autor'].setValue(this.loggedService.logged.userName);
        this.tablasService.aTipoListaPrecio(this.form.value).subscribe((data: boolean) => {
          this.mensaje = this.idTipo;
          this.dialogRef.close();
        })
        break;

      case 2:

        this.tablasService
          .mTipoListaPrecio(this.form.value)
          .subscribe((data: boolean) => {
            this.mensaje = this.idTipo;
            this.dialogRef.close();
          });
        break;
    }

  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }

  clearInput(formControlName: string) {
    this.form.controls[formControlName].reset();
  }

  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }

}
